import _indexOf from 'lodash/indexOf';

import { ELEMENT_TYPE_DISPLAY_ORDER } from './EditElementTabs.constants';
import {
  FORM_BLOCK_ELEMENT_TYPE,
  LEGACY_FORM_BLOCK_ELEMENT_TYPE,
  ACCORDION_BLOCK_ELEMENT_TYPE,
  VIDEO_BLOCK_ELEMENT_TYPE,
} from '../../../../constants/types';

export function getActiveTabIndex(elementTypes, type) {
  if (type === LEGACY_FORM_BLOCK_ELEMENT_TYPE) {
    return _indexOf(elementTypes, FORM_BLOCK_ELEMENT_TYPE);
  }
  return _indexOf(elementTypes, type);
}

export function getAllowedElementTypes({ enableAccordion, enableVideo }) {
  const elementTypeExcludeList = [];
  if (!enableAccordion) {
    elementTypeExcludeList.push(ACCORDION_BLOCK_ELEMENT_TYPE);
  }
  if (!enableVideo) {
    elementTypeExcludeList.push(VIDEO_BLOCK_ELEMENT_TYPE);
  }

  return ELEMENT_TYPE_DISPLAY_ORDER.filter((type) => !elementTypeExcludeList.includes(type));
}
